import { IncidentLogMessage } from "features/CenterContent/RoleContent/ISirk/types";
import { LogEntry } from "features/CenterContent/VehicleDetails/shared/LogEntry";
import { FC } from "react";
import {
  DialogRoot,
  DropsDialogContent,
  DropsDialogHeader,
  DialogBody as SporDialogBody,
} from "shared/components/Spor";
import { ObtrusiveScrollCss } from "shared/components/transitions/scroll";
import { compareDateStringAsc } from "shared/utils/dateTimeUtils";
import styled from "styled-components";

const LogList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  row-gap: 0px;
`;

const DialogBody = styled(SporDialogBody)`
  ${ObtrusiveScrollCss};
`;

type ReadLogMessagesModalProps = {
  open: boolean;
  setopen: (open: boolean) => void;
  isirkId: string;
  messages: IncidentLogMessage[];
};

const ReadLogMessagesModal: FC<ReadLogMessagesModalProps> = ({
  open,
  setopen,
  messages,
  isirkId,
}) => (
  <DialogRoot open={open} onOpenChange={() => setopen(false)}>
    <DropsDialogContent overflowY="scroll" maxH="80vh" minH="50vh" minW="800px">
      <DropsDialogHeader>Loggmeldinger på I-Sirk {isirkId}</DropsDialogHeader>
      <DialogBody>
        <LogList>
          {messages
            .sort((a, b) => compareDateStringAsc(a.timestamp, b.timestamp))
            .map(({ id, timestamp, message, sourceSystem }, index) => (
              <LogEntry
                key={id}
                timestamp={timestamp}
                message={message}
                source={sourceSystem.author?.split("@")[0]}
                fallbackSource={sourceSystem.name}
                hideDashedLine={index === messages.length - 1}
              />
            ))}
        </LogList>
      </DialogBody>
    </DropsDialogContent>
  </DialogRoot>
);
export default ReadLogMessagesModal;
